import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  private router = inject(Router);

  private currentUrlSignal = signal<string>(''); 
  readonly currentUrl: Signal<string> = computed(() => this.currentUrlSignal());

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrlSignal.set(event.urlAfterRedirects);
      });
  }

  getCurrentUrl(): string {
    return this.currentUrl();
  }
}
